module.exports = __webpack_public_path__ + "img/kobe2.6c657f96.png";